import React from "react";

const StripSection = () => {
  return (
    <div className="strip-section section">
      <h2 className="text-center">Key Features</h2>
      <div className="container">
        <ul className="strip_section-row">
          <li>
            <div className="strip-box">
              <div className="title">2 & 3 BHK Homes</div>
              <div className="sub_title">Configuration</div>
            </div>
          </li>
          <li>
            <div className="strip-box">
              <div className="title">104 Acres Mega Township</div>
              <div className="sub_title">Land Parcel</div>
            </div>
          </li>
          <li>
            <div className="strip-box">
              <div className="title">30 Storeys</div>
              <div className="sub_title">Floors</div>
            </div>
          </li>
          <li>
            <div className="strip-box">
              <div className="title">Under Construction</div>
              <div className="sub_title">Project Status</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default StripSection;
